import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useBranding } from "@/hooks/useBranding";

const sectionsFor = (name) => [
  {
    title: "1. Acceptance",
    body: `By using ${name}, you agree to these terms. If you do not agree, do not use the app.`,
  },
  {
    title: "2. Description of Service",
    body: `${name} is a queue management platform that connects patients with healthcare providers. Patients can browse doctors, book appointments (tokens), manage family members, and track their queue. Doctors can manage their schedules and patient flow.`,
  },
  {
    title: "3. User Accounts",
    body: "You must provide accurate information when registering. You are responsible for keeping your account credentials secure. You must be at least 18 years old to use the app. Minors must use under a parent or guardian's account.",
  },
  {
    title: "4. Bookings & Cancellations",
    body: "Appointments are on a token/queue basis — not a fixed time slot. You may cancel your token at any time. Repeated no-shows may result in account restrictions. Doctors may cancel or reschedule appointments at their discretion.",
  },
  {
    title: "5. User Conduct",
    body: "You agree not to use the app for any unlawful purpose, harass or abuse healthcare providers or other users, attempt to manipulate the queue or booking system, or submit false or misleading information.",
  },
  {
    title: "6. Limitation of Liability",
    body: `${name} is a platform connecting patients and doctors. We are not responsible for the quality of medical care provided, cancellations or schedule changes by healthcare providers, or any loss or damage arising from your use of the app.`,
  },
  {
    title: "7. Termination",
    body: "We reserve the right to suspend or terminate accounts that violate these terms.",
  },
  {
    title: "8. Changes",
    body: "We may update these terms at any time. Continued use after changes means you accept the new terms.",
  },
];

export default function TermsPage() {
  const branding = useBranding();
  const sections = sectionsFor(branding.product_name || "Qenqo");
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="font-display font-bold text-3xl sm:text-4xl text-foreground tracking-tight">Terms & Conditions</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-8">Last updated: May 2026</p>
        <div className="space-y-6">
          {sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display font-semibold text-lg text-foreground">{s.title}</h2>
              <p className="text-sm text-foreground mt-1.5 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
